import type { FC } from 'react';
import { useSelector } from 'react-redux';

import { CheckBox } from '@interstate/components/CheckBox';
import { Box } from '@interstate/components/Box';
import { dealLockHooks } from '@makemydeal/dr-dash-components';

import { useFeesFormContext } from './useFeesFormContext';

import type { CellLeaseDetailsProps } from './types';

import * as feesUtils from '@makemydeal/dr-dash-store/utils/feesUtils';

export const LeaseUpfrontCell: FC<CellLeaseDetailsProps> = ({ detail, index }) => {
    const isLocked = dealLockHooks.useIsDealLocked();
    const { handleInputChange, commitFeeSoftSaveDebounced } = useFeesFormContext();
    const isAllFeesCapitalized = useSelector(feesUtils.isTermAllFeesCapitalized);
    const isUpfrontChecked = isAllFeesCapitalized ? false : Boolean(detail.upfront);

    return (
        <Box data-testid="edit-fee--upfront-cell" display="flex" alignItems="center">
            <CheckBox
                sx={{
                    backgroundColor: 'inherit'
                }}
                name="capIndicator"
                checked={isUpfrontChecked}
                label="Upfront"
                value={`${detail.upfront}-${index}`}
                data-testid={`edit-fee--upfront-cell-${index}`}
                disabled={detail.isDeleted || isLocked}
                onChange={() => {
                    handleInputChange({
                        category: detail.category,
                        field: 'capIndicator',
                        index,
                        value: isUpfrontChecked
                    });
                    commitFeeSoftSaveDebounced();
                }}
            />
        </Box>
    );
};
